<template>
    <div class="dim__properties">
        <dl>
            <dt>{{ t("components.carat") }}:</dt>
            <dd>{{ carat }} {{ t("components.ct") }}</dd>

            <dt>{{ t("components.shape") }}:</dt>
            <dd>{{ t(`diamondProperties.shape.${shape}`) }}</dd>

            <dt>{{ t("components.clarity") }}:</dt>
            <dd>
                {{ t(`diamondProperties.clarity.${clarity}`) }}
            </dd>

            <dt>{{ t("components.color") }}:</dt>
            <dd>
                {{ t(`diamondProperties.color.${color}`) }}&nbsp;({{ color }})
            </dd>

            <dt>{{ t("components.cut") }}:</dt>
            <dd>{{ cut ? t(`diamondProperties.cut.${cut}`) : "-" }}</dd>

            <dt>ID:</dt>
            <dd>{{ productId }}</dd>
        </dl>
    </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType} from "vue";
import {Diamond} from "@/api/Diamond";
import useDiamondProperties from "@/composables/useDiamondProperties";
import {useI18n} from "vue-i18n";

export default defineComponent({
    name: "DiamondProperties",
    props: {
        diamond: {
            type: Object as PropType<Diamond>,
            required: true
        }
    },
    setup(props) {
        const {
            carat,
            clarity,
            color,
            cut,
            shape,
            productId
        } = useDiamondProperties(computed(() => props.diamond));

        return {...useI18n(), carat, clarity, color, cut, shape, productId};
    }
});
</script>

<style>
.dim__properties {
    width: 100%;
}

.dim__properties dl {
    display: grid;
    grid-template-columns: max-content auto;
    margin: 0;
    column-gap: 26px;
}

.dim__properties dt {
    grid-column-start: 1;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #8A8989;
}

.dim__properties dd {
    grid-column-start: 2;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
}
</style>
